// extracted by mini-css-extract-plugin
export var contrastLow = "_3j-1";
export var externalLink = "_3j-2";
export var externalLinkIcon = "_3j-3";
export var link = "_3j-0";
export var linkLabel = "_3j-4";